import styled from 'styled-components';

interface ToggleProps {
  readonly isChecked: boolean;
}

const Toggle = styled.div<ToggleProps>`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  > .check {
    width: 30px;
    height: 30px;
    background-color: ${props => (props.isChecked ? props.theme.colors.success : props.theme.colors.error)};
    border-radius: 4px;
    border-color: grey;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
  }
`;

export default Toggle;
